/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  GameEvent,
  GameEventInput,
  GameEvents,
  GameEventsParams,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create Game Event
 */
export const createGameEvent = (
    gameEventInput: MaybeRefOrGetter<GameEventInput>,
 signal?: AbortSignal
) => {
      gameEventInput = toValue(gameEventInput);

      return axiosClient<GameEvent>(
      {url: `/game-events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: gameEventInput, signal
    },
      );
    }




export const getCreateGameEventMutationKey = () => ['createGameEvent'] as const;

export const getCreateGameEventMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGameEvent>>, TError,CreateGameEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createGameEvent>>, TError,CreateGameEventMutationVariables, TContext> => {

const mutationKey = getCreateGameEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGameEvent>>, CreateGameEventMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createGameEvent(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGameEventMutationResult = NonNullable<Awaited<ReturnType<typeof createGameEvent>>>
    export type CreateGameEventMutationBody = GameEventInput
    export type CreateGameEventMutationError = ErrorType<ValidationError | StandardError>
    export type CreateGameEventMutationVariables = {data: GameEventInput}

    /**
 * @summary Create Game Event
 */
export const useCreateGameEvent = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGameEvent>>, TError,CreateGameEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createGameEvent>>,
        TError,
        CreateGameEventMutationVariables,
        TContext
      > => {
      return useMutation(getCreateGameEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Game Events list
 */
export const gameEvents = (
    params?: MaybeRefOrGetter<GameEventsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<GameEvents>(
      {url: `/game-events`, method: 'GET',
        params, signal
    },
      );
    }




export const getGameEventsQueryKey = (params?: MaybeRefOrGetter<GameEventsParams>,) => {
    return [
    'game-events', ...(params ? [params] : [])
    ] as const;
    }


export const getGameEventsQueryOptions = <TData = Awaited<ReturnType<typeof gameEvents>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<GameEventsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameEvents>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGameEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gameEvents>>> = ({ signal }) => gameEvents(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gameEvents>>, TError, TData>
}

export type GameEventsQueryResult = NonNullable<Awaited<ReturnType<typeof gameEvents>>>
export type GameEventsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Game Events list
 */

export function useGameEvents<TData = Awaited<ReturnType<typeof gameEvents>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<GameEventsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameEvents>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGameEventsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Game Event
 */
export const destroyGameEvent = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<GameEvent>(
      {url: `/game-events/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyGameEventMutationKey = () => ['destroyGameEvent'] as const;

export const getDestroyGameEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyGameEvent>>, TError,DestroyGameEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyGameEvent>>, TError,DestroyGameEventMutationVariables, TContext> => {

const mutationKey = getDestroyGameEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyGameEvent>>, DestroyGameEventMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyGameEvent(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyGameEventMutationResult = NonNullable<Awaited<ReturnType<typeof destroyGameEvent>>>

    export type DestroyGameEventMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyGameEventMutationVariables = {id: string}

    /**
 * @summary Destroy Game Event
 */
export const useDestroyGameEvent = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyGameEvent>>, TError,DestroyGameEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyGameEvent>>,
        TError,
        DestroyGameEventMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyGameEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Game Event Detail
 */
export const gameEvent = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<GameEvent>(
      {url: `/game-events/${id}`, method: 'GET', signal
    },
      );
    }




export const getGameEventQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'game-events',id
    ] as const;
    }


export const getGameEventQueryOptions = <TData = Awaited<ReturnType<typeof gameEvent>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameEvent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGameEventQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof gameEvent>>> = ({ signal }) => gameEvent(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gameEvent>>, TError, TData>
}

export type GameEventQueryResult = NonNullable<Awaited<ReturnType<typeof gameEvent>>>
export type GameEventQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Game Event Detail
 */

export function useGameEvent<TData = Awaited<ReturnType<typeof gameEvent>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gameEvent>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGameEventQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Game Event
 */
export const updateGameEvent = (
    id: MaybeRefOrGetter<string>,
    gameEventInput: MaybeRefOrGetter<GameEventInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
gameEventInput = toValue(gameEventInput);

      return axiosClient<GameEvent>(
      {url: `/game-events/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: gameEventInput, signal
    },
      );
    }




export const getUpdateGameEventMutationKey = () => ['updateGameEvent'] as const;

export const getUpdateGameEventMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGameEvent>>, TError,UpdateGameEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateGameEvent>>, TError,UpdateGameEventMutationVariables, TContext> => {

const mutationKey = getUpdateGameEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGameEvent>>, UpdateGameEventMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateGameEvent(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateGameEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateGameEvent>>>
    export type UpdateGameEventMutationBody = GameEventInput
    export type UpdateGameEventMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateGameEventMutationVariables = {id: string;data: GameEventInput}

    /**
 * @summary Update Game Event
 */
export const useUpdateGameEvent = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGameEvent>>, TError,UpdateGameEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateGameEvent>>,
        TError,
        UpdateGameEventMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateGameEventMutationOptions(options), queryClient);
    }
